import { render, staticRenderFns } from "./cacheManageTable.vue?vue&type=template&id=946e1ac6&scoped=true"
import script from "./cacheManageTable.vue?vue&type=script&lang=js"
export * from "./cacheManageTable.vue?vue&type=script&lang=js"
import style0 from "./cacheManageTable.vue?vue&type=style&index=0&id=946e1ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946e1ac6",
  null
  
)

export default component.exports